export default {
    name: 'shippingPrintLabel',
    before: [],
    after: [],
    setup: (app) => {
        function moveElementToEnd(array, label) {
            const index = array.findIndex((item) => item.label === label);
            if (index !== -1) {
                const [element] = array.splice(index, 1);
                array.push(element);
            }
        }
        
        const customAttributeList = ({ attributes = [], ...rest }) => {
            const newAttributes = attributes.filter(({ label }) =>
                ['Order Number', 'Customer', 'Shipment Address', 'Customer Phone', 'Customer Email'].includes(label),
            );
            moveElementToEnd(newAttributes, 'Customer Phone');
            moveElementToEnd(newAttributes, 'Shipment Address');
        
            return {
                ...rest,
                attributes: newAttributes,
            };
        };

        const shipmentPrint = app.routes.getItem('shipmentPrint');
        if (shipmentPrint) {
            
            const shipmentPrintProps = shipmentPrint.props;

            shipmentPrint.props = (state) => ({
                ...shipmentPrintProps(state),
                defaultConfig: {
                    details: {
                        props: {
                            customAttributeList,
                        },
                    },
                },
                carriersConfig: {
                    sagawa: {
                        default: {
                            page: {
                                size: {
                                    width: '4.133',
                                    height: '8.267in',
                                },
                            },
                            label: {
                                size: {
                                    width: '4.133',
                                    height: '8.267in',
                                },
                            },
                        },
                    },
                    australiapost: {
                        default: {
                            label: {
                                props: {
                                    labelStyle: {
                                        marginTop: '-30px',
                                    },
                                },
                            },
                        },
                    },
                },
            });

            app.routes.changeItem('shipmentPrint', shipmentPrint);
        }
    },
};
